
import React from "react";
import { motion } from "framer-motion";

interface ShineEffectProps {
  isActive: boolean;
}

const ShineEffect: React.FC<ShineEffectProps> = ({ isActive }) => {
  if (!isActive) return null;
  
  return (
    <motion.div 
      className="absolute inset-0 pointer-events-none overflow-hidden rounded-md"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="w-20 h-full bg-gradient-to-r from-transparent via-primary/20 to-transparent"
        animate={{
          x: ["calc(-100%)", "calc(300%)"],
        }}
        transition={{
          duration: 1.5,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop",
          repeatDelay: 0.5,
        }}
      />
    </motion.div>
  );
};

export default ShineEffect;
